import React, { useEffect, useState } from 'react';
import Detailcard from './Details';
import { Container, Row, Col } from 'react-bootstrap';
import Pagination from 'react-bootstrap/Pagination';
import { ApiCall } from '../../apicall';
import './queryStyle.css';
import { Microphone } from 'phosphor-react';
import { useNavigate } from 'react-router-dom';
import fieldsLang from './fieldsLang.json';
import JasonFile from './langVoiceCodes.json';
import Spinner from 'react-bootstrap/Spinner';
import { Link } from 'react-router-dom';

function QueryPage() {
  const navigate = useNavigate();
  const [currentLang, setCurrentLang] = useState('en-IN');
  const [isSchemeSelected, setIsSchemeSelected] = useState(false);
  const [mdkUserDate, setmdkUserDate] = useState([]);

  useEffect(() => {
    let langvalue = localStorage.getItem('selectedLang');
    if (langvalue) {
      TranslationAPIMethod(langvalue);
      setCurrentLang(langvalue);
    } else {
      TranslationAPIMethod("en-IN");
      setCurrentLang("en-IN");
    }
  }, []);

  const TranslationAPIMethod = async (value, res, setField) => {
    const post = { outputLang: value }
    await ApiCall('get', 'fetch-mkb-translated-comments', '', { params: { post } })
      .then(resp => {
        setmdkUserDate(resp.data);
        let ram = resp.data;
        let TranslateQueryArray = [];
        ram.map(it => {
          const { text } = it.translations[0];
          TranslateQueryArray.push(text);
        });

        setField(TranslateQueryArray);
      })
      .catch(err => {
        console.log(err);
      });
  };

  // =========Pagination logic=========
  const [currentPage, setCurrentPage] = useState(1);
  const [postPerPage, setPostPerPage] = useState(6);
  const lastPostIndex = currentPage * postPerPage;
  const firstPostIndex = lastPostIndex - postPerPage;
  const c_post = mdkUserDate.slice(firstPostIndex, lastPostIndex);
  const total_page = Math.ceil(mdkUserDate.length / postPerPage);
  const page_arr = [...Array(total_page).keys()];
  // =========Pagination logic=========

  const handleLanguage = async value => {
    localStorage.setItem('selectedLang', value);
    setCurrentLang(value);
  };


  //ask questions
  const sendQueryAsInput = async (data) => {
    localStorage.setItem('SelectedQueryAsInput', data);
    navigate('/govtofindiascheme/Selected-query');
  };

  const handleClick = () => {
    navigate('/mkb100/form');
  };

  return (
    <>
      <div className="ui large breadcrumb">
        <Link to="https://anuvadini.aicte-india.org/" className="section">Home</Link> <span>/</span>
        <i className="right chevron icon divider"></i>
        <div className="active section">Maan ki Baat</div>
      </div>

      <Container>
        <Row className='justify-content-center'>
          <div className='iframe-container ifcon'><iframe width="100%" height="500px" src="https://www.youtube.com/embed/-Sb6uW_ReH0" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe></div>

          <div className='row'>
            <button className='blink' onClick={handleClick} style={{ maxWidth: 200, margin: "0 auto" }}>Share Your Views </button>
          </div>

          <div className="cardtitle displaytwo mt-5 d-flex justify-content-between align-items-center">
            <div className="select-dropdown" style={{ marginRight: 10 }}>
              <select value={currentLang}
                onChange={e => {
                  handleLanguage(e.target.value);
                  TranslationAPIMethod(e.target.value, JSON.stringify(mdkUserDate[2]))
                }}>
                {Object.entries(JasonFile[0]).map((res, i) => {
                  return (
                    <option key={i} value={res[0]}>
                      {res[1]}
                    </option>
                  );
                })}
              </select>
            </div>

            <div className='d-flex justify-content-end align-items-center'>
              <button
                onClick={() => {
                  navigate('/mkb100/form');
                }}
                style={{
                  width: 'max-content',
                  paddingLeft: 15,
                  paddingRight: 15,
                }}>

                {fieldsLang[10][currentLang]} {' '}
                <Microphone size={24} weight="fill" />
              </button>
            </div>
          </div>
          {mdkUserDate.length > 0 ? <>
            {mdkUserDate && c_post.map((userData, key) => (
              <Col lg={4} className="card-div" key={key} >

                <Detailcard
                  imagesrc={userData.profilePicture}
                  title={userData.name}
                  disc={userData.body}
                  currentLang={currentLang}
                />
              </Col>
            ))}
          </> : <>
            <div className="newload">
              <Spinner animation="border" role="status" variant="dark" >
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          </>}

          {!isSchemeSelected && mdkUserDate && mdkUserDate.length > 0 ? (
            c_post.map((it, key) => (
              <Col lg={4} className="card-div" key={key}>
              </Col>
            ))
          ) : (
            <></>
          )}
          {!isSchemeSelected ? (
            <div className="d-flex justify-content-center">
              <Pagination>
                {page_arr.map((i, x) => (
                  <Pagination.Item
                    key={i}
                    onClick={() => {
                      setCurrentPage(i + 1);
                    }}
                    active={i + 1 === currentPage}>
                    {i + 1}
                  </Pagination.Item>
                ))}
              </Pagination>
            </div>
          ) : (
            <div></div>
          )}
        </Row>
      </Container>
    </>
  );
}

export default QueryPage;
